import { useEffect } from 'react';

const useRedLandMarks = ({ responseLandMarks }) => {
  useEffect(() => {
    if (responseLandMarks) {
      localStorage.setItem('redlandmark', responseLandMarks);
    }
  }, [responseLandMarks]);
};

export default useRedLandMarks;
